<template>
    <section id="databiro">
    <div class="rows">
        <div class="rows">
            <div class="box mw-980">
            <h4 class="title is-5 has-text-centered">{{ actionTitle }} Data Biro</h4>
            <section>
                <!-- <p style="color:red;%"> *) Wajib Diisi</p> -->
                <b-field label="Nama Biro/Universitas*" horizontal>
                    <b-field  custom-class="is-small has-text-danger" 
                    :type="form.nama_biro.type"
                    :message="form.nama_biro.message">
                        <b-input name="nama_biro" @input="clearError(form.nama_biro)"
                        placeholder="Nama Biro" v-model="form.nama_biro.value" expanded></b-input>
                    </b-field>
                </b-field>
                <b-field label="Alamat*" horizontal>
                    <b-field  custom-class="is-small has-text-danger" 
                    :type="form.alamat_biro.type"
                    :message="form.alamat_biro.message">
                        <b-input name="alamat" @input="clearError(form.alamat_biro)" 
                        placeholder="Alamat" v-model="form.alamat_biro.value" expanded></b-input>
                    </b-field>
                </b-field>
                <b-field label="Provinsi*" horizontal>
                    <b-field  custom-class="is-small has-text-danger" 
                    :type="form.provinsi.type"
                    :message="form.provinsi.message">
                    <b-input name="provinsi" @input="clearError(form.provinsi)" 
                    placeholder="Provinsi" v-model="form.provinsi.value" expanded></b-input>
                    </b-field>
                </b-field>
                <b-field label="Kota*" horizontal>
                    <b-field  custom-class="is-small has-text-danger" 
                    :type="form.kota.type"
                    :message="form.kota.message">
                    <b-input name="kota" @input="clearError(form.kota)" 
                    placeholder="Kota" v-model="form.kota.value" expanded></b-input>
                </b-field>
                </b-field>
                <!-- <b-field label="No Telepon*" horizontal>
                    <b-field label="*)Required" custom-class="is-small has-text-danger" 
                        :type="form.no_telepon.type"
                        :message="form.no_telepon.message">
                        <b-button label="+62" 
                            type="is-light">
                        </b-button>
                            <b-input name="no_telepon" placeholder="No Telepon" v-model="form.no_telepon.value" style="padding-right:600px"
                            @input="clearError(form.no_telepon)" expanded></b-input>
                    </b-field>
                    </b-field> -->
                    <b-field horizontal label="No Telepon">
                    <b-field custom-class="is-small has-text-danger" 
                    :type="form.no_telepon.type"
                    :message ="form.no_telepon.message">

                    <div class="columns">
                        <div class="column is-1">
                            <b-button label="+62" 
                                type="is-light"
                                disabled>
                            </b-button>
                        </div>
                        <div class="column">
                            <b-input name="no_telepon" placeholder="No Telepon" 
                                @input="clearError(form.no_telepon)" v-model="form.no_telepon.value" expanded>
                            </b-input>
                        </div>
                    </div>
                    </b-field>
                    </b-field>

                    <br>
                <b-field label="Email*" horizontal>
                    <b-field  custom-class="is-small has-text-danger" 
                    :type="form.email.type"
                    :message="form.email.message">
                    <b-input type="email" name="email"  @input="clearError(form.email)" 
                    placeholder="Email" v-model="form.email.value" expanded></b-input>
                    </b-field>
                </b-field>
                
                <b-field horizontal label="Koordinator" v-if="koordinator_form"
                :type="form.nama_personil.type"
                :message="form.nama_personil.message">
                    <b-select v-model="form.nama_personil.value" @input="clearError(form.nama_personil)"  
                    placeholder="Select one" expanded>
                        <option v-for="(item) in personil_biro"
                        :key="item.id_personil"
                        :value="item.id_personil">
                        {{ item.nama_personil}}
                        </option>>
                    </b-select>
                </b-field>
                    <!-- <b-field horizontal label="Paket Standar" v-if="standar_form" 
                :type="form.nama_paket_standar.type"
                :message="form.nama_paket_standar.message">
                    <b-select v-model="form.nama_paket_standar.value" @input="clearError(form.nama_paket_standar)"  
                    placeholder="Select one" expanded>
                        <option v-for="(item) in standar"
                        :key="item.id_paket"
                        :value="item.id_paket">
                        {{ item.nama_paket}}
                        </option>>
                    </b-select>
                </b-field> -->
                <!-- <b-field horizontal label="Paket Tambahan" v-if="tambahan_form  && form.nama_paket_standar.value !== ''"
                :type="form.nama_paket_tambahan.type"
                :message="form.nama_paket_tambahan.message">
                    <b-select v-model="form.nama_paket_tambahan.value" @input="clearError(form.nama_paket_tambahan)"  
                    placeholder="Select one" expanded>
                        <option v-for="(item) in tambahan"
                        :key="item.id_paket"
                        :value="item.id_paket">
                        {{ item.nama_paket}}
                        </option>>
                    </b-select>
                </b-field> -->
                <b-field horizontal label="Paket Standar" v-if="standar_form" 
                :type="form.nama_paket_standar.type"
                :message="form.nama_paket_standar.message">
                    <b-autocomplete 
                    v-model="searchStandar" 
                    @input="clearError(form.nama_paket_standar)"  
                    @blur="form.nama_paket_standar.value = ''; form.nama_paket_tambahan.value = ''"
                    @select="option => (form.nama_paket_standar.value = option.id_paket)"
                    open-on-focus
                    :data="filterStandar"
                    clearable
                    field="nama_paket"
                    placeholder="Select one" expanded>
                        
                    </b-autocomplete>
                </b-field>
                <b-field  horizontal label="Paket Tambahan" v-if="tambahan_form  && form.nama_paket_standar.value !== ''"
                :type="form.nama_paket_tambahan.type"
                :message="form.nama_paket_tambahan.message">
                    <b-autocomplete 
                    v-model="searchTambahan" 
                    @input="clearError(form.nama_paket_tambahan)"  
                    @blur="form.nama_paket_tambahan.value = ''"
                    @select="option => (form.nama_paket_tambahan.value = option.id_paket)"
                    open-on-focus
                    :data="filterTambahan"
                    clearable
                    field="nama_paket"
                    placeholder="Select one" expanded>
                        
                    </b-autocomplete>
                </b-field>
                <b-field horizontal>
                    <p class="control">
                        <button class="button is-primary"
                        @click="confirm()">
                        Simpan
                        </button>
                    </p>
                </b-field>
            </section>
            <div class="rows" style="margin-top: 24px">
                <div class="row">
                    <div class="columns">
                        <div class="column">
                            <b-button type="is-danger" 
                            class="mw-420" 
                            tag="router-link"
                            to="/biro/berandabiro">Batal</b-button>
                        </div>
                        <div class="column">
                            <b-button type="is-info" class="mw-420" @click="confirm()">Simpan</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
        <!-- <b-loading
            :is-full-page="true"
            :active.sync="isLoading"
            :can-cancel="false">
        </b-loading> -->
        <b-loading
            :is-full-page ="true"
            :active.sync="isLoading"
            :can-cancel="false">
        </b-loading>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                isLoading:false,
                actionTitle:'',
                editID:0,
                clearableStandar: true,
                openOnFocusStandar: true,
                clearableTambahan: true,
                openOnFocusTambahan: true,
                dataBiro: new FormData(),
                editDataBiro:{},
                form:
                {
                   nama_biro:{
                       value:'', type:'', message:''
                   },
                   alamat_biro:{
                        value:'', type:'', message:''
                   },
                   provinsi:{
                        value:'', type:'', message:''
                   },
                   kota:{
                        value:'', type:'', message:''
                   },
                   no_telepon:{
                       value:'', type:'', message:''
                   },
                   email:{
                       value:'', type:'', message:''
                   },
                   nama_personil:{
                        value:'', type:'', message:''
                   },
                   nama_paket_standar:{
                        value:'', type:'', message:''
                   },
                   nama_paket_tambahan:{
                        value:'', type:'', message:''
                   }
                },
                // snackbarMessage:'',
                personil_biro:[],
                paket:[],
                standar:[],
                tambahan:[],
                standar_form:false,
                tambahan_form:false,
                koordinator_form:false,
                config: {},
                searchStandar: '',
                searchTambahan: '',
            }
        },
        computed: {
            filterStandar() {
                return this.standar.filter(option => {
                    return (
                        option.nama_paket
                            .toString()
                            .toLowerCase()
                            .indexOf(this.searchStandar.toLowerCase()) >= 0
                    )
                })
            },

            filterTambahan() {
                return this.tambahan.filter(option => {
                    return (
                        option.nama_paket
                            .toString()
                            .toLowerCase()
                            .indexOf(this.searchTambahan.toLowerCase()) >= 0
                    )
                })
            }
        },
        methods:{
            // Choose()
            // {
            //     if(form.)
            // }
            getPersonilBiro(editID)
            {
                var uri = this.$apiUrl + 'personil_biro/biro/' + editID
                this.$http.get(uri, this.config).then(response =>
                {
                    var temp = response.data.value
                    for(var i=0; i<temp.length;i++){
                        if(temp[i].jabatan === "Koordinator Biro"){
                            this.personil_biro.push(temp[i])
                        }
                    }
                    
                    console.log(this.personil_biro)
                })
            },
            getPaket() 
            {
                var uri = this.$apiUrl + 'paket' 
                this.$http.get(uri, this.config).then((response) => {
                this.paket = response.data.value;//get paket terlebih dahulu
                for (var i = 0; i < this.paket.length; i++) {
                    if (this.paket[i].jenis_paket === "Standar") { //dicari yg jenis paketnya standart
                        this.standar.push(this.paket[i]); //lalu dr jenispaket di tbl paket dipush ke standart
                    }else if(this.paket[i].jenis_paket === "Tambahan"){
                        this.tambahan.push(this.paket[i]);
                    }
                }
                console.log(this.standar)
                });
            },
            getData(editID)//get one biro
            {
                var uri = this.$apiUrl + 'biro/' + editID
                 
                this.$http.get(uri, this.config).then(response=>{
                 this.editDataBiro = response.data.value
                 //console.log(this.editDataBiro)
                 this.formEdit(this.editDataBiro)
                //  this.isLoading = false
                })
            },
            formEdit(dataBiro)
            {
                this.form.nama_biro.value = dataBiro.nama_biro
                this.form.alamat_biro.value = dataBiro.alamat_biro
                this.form.provinsi.value = dataBiro.provinsi 
                this.form.kota.value = dataBiro.kota
                this.form.no_telepon.value = dataBiro.no_telepon
                this.form.email.value = dataBiro.email
                this.form.nama_personil.value = dataBiro.id_koordinator

                if(dataBiro.paket_standart === null)
                {
                    this.form.nama_paket_standar.value = ''
                }else{
                    this.form.nama_paket_standar.value = dataBiro.paket_standart
                    this.searchStandar = dataBiro.nama_paket_standart
                }

                if(dataBiro.paket_tambahan === null)
                {
                    this.form.nama_paket_tambahan.value = ''
                }else{
                   this.form.nama_paket_tambahan.value = dataBiro.paket_tambahan
                   this.searchTambahan = dataBiro.nama_paket_tambahan
                }

                // this.form.nama_paket_tambahan.value = dataBiro.paket_tambahan
                // this.searchTambahan = dataBiro.nama_paket_tambahan
                
                

                console.log(dataBiro)
                console.log(this.form)
            },
            clearError(form)
            {
                console.log(form)
                form.type = ''
                form.message = ''
            },
            checkData()
            {
                // this.isLoading = false
                let count = 0
                let regexTelp = new RegExp(/^\d+$/)
                let regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
                // let regexEmail = new RegExp(/^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/)
                // let regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
                if(this.form.nama_biro.value === "")
                {
                    this.form.nama_biro.type = 'is-danger'
                    this.form.nama_biro.message = "Nama harus di isi"
                    count ++
                }
                if(this.form.alamat_biro.value === "")
                {
                    this.form.alamat_biro.type = 'is-danger'
                    this.form.alamat_biro.message ="Alamat harus diisi"
                    count ++
                }
                if(this.form.provinsi.value === "")
                {
                    this.form.provinsi.type = 'is-danger'
                    this.form.provinsi.message ="Provinsi harus diisi"
                    count ++
                }
                if(this.form.kota.value === "")
                {
                    this.form.kota.type = 'is-danger'
                    this.form.kota.message ="Kota harus diisi"
                    count ++
                }
                if(this.form.no_telepon.value ==="")
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message ="No telepon harus diisi"
                    count ++
                }else if(!regexTelp.test(this.form.no_telepon.value))
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message ="No telepon diisi tanpa spasi dan karakter"
                    count ++
                }else if(this.form.no_telepon.value.length < 8 || this.form.no_telepon.value.length > 13)
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message ="Panjang No Telepon 8 - 13 digit"
                    count ++

                }
                if(this.form.email.value ==="")
                {
                    this.form.email.type = 'is-danger'
                    this.form.email.message ="Email harus diisi"
                    count ++
                }else if(!regexEmail.test(this.form.email.value))
                {
                    this.form.email.type = 'is-danger'
                    this.form.email.message ="Email harus valid"
                    count ++
                }
               
                if(count >0)
                return false
            },
            tambahData()
            {
                this.isLoading = true
                if(this.checkData()== false)
                {
                    this.snackbar("Gagal...Silahkan input lagi", 'is-danger')
                    this.isLoading = false
                }else{
                    this.dataBiro.append("nama_biro",this.form.nama_biro.value)
                    this.dataBiro.append("alamat_biro",this.form.alamat_biro.value)
                    this.dataBiro.append("provinsi",this.form.provinsi.value)
                    this.dataBiro.append("kota",this.form.kota.value)
                    this.dataBiro.append("email",this.form.email.value)
                    this.dataBiro.append("no_telepon",this.form.no_telepon.value)
                    this.dataBiro.append("id_koordinator",this.form.nama_personil.value)

                    var uri =this.$apiUrl + 'biro';
                    this.$http.post(uri,this.dataBiro, this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({ name :'BerandaBiro'})
                        this.snackbarMessage = response.data.message
                        this.snackbar("Data Berhasil Ditambahkan..",'is-success')
                    })
                    .catch(error=>{
                        this.isLoading = false
                        this.errors = error;
                        console.log(this.errors)
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Ditambahkan",'is-danger')
                        }else{
                            this.snackbar("Ada Inputan Salah.Silahkan coba lagi",'is-danger')
                        }
                    });
                }
            },
            editData(editID)
            {
                this.isLoading = true
                if(this.checkData()== false)
                {
                    this.snackbar("Gagal Diedit",'is-danger')
                    this.isLoading = false
                }else{
                    this.editDataBiro.nama_biro = this.form.nama_biro.value
                    this.editDataBiro.alamat_biro =this.form.alamat_biro.value
                    this.editDataBiro.provinsi =this.form.provinsi.value
                    this.editDataBiro.kota =this.form.kota.value
                    this.editDataBiro.email = this.form.email.value
                    this.editDataBiro.no_telepon = this.form.no_telepon.value
                    this.editDataBiro.id_koordinator = this.form.nama_personil.value
                    this.editDataBiro.paket_standart = this.form.nama_paket_standar.value
                    this.editDataBiro.paket_tambahan = this.form.nama_paket_tambahan.value

                    console.log(editID)
                    console.log(this.editDataBiro)

                    var uri = this.$apiUrl + 'biro/' + editID;
                    this.$http.post(uri,this.editDataBiro, this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({name: 'BerandaBiro'})
                        this.snackbarMessage = response.data.message
                        console.log(response.data.value)
                        this.snackbar("Data Berhasil Diedit",'is-success')
                    })
                    .catch(error=>{
                        this.isLoading = false
                        this.errors = error;
                        console.log(this.errors)
                        
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Diedit",'is-danger')
                        }else{
                            this.snackbar("Ada Inputan Salah.Silahkan coba lagi",'is-danger')
                        }
                    });
                }
                // this.isLoading = false
            },
            confirm()
            {
                this.editID == 0? this.tambahData() : this.editData(this.editID)
            },
            snackbar(snackbarMessage,type)
            {
                this.$buefy.toast.open({
                    duration : 5000, //3 detik
                    message: snackbarMessage,
                    //type: type,
                    position: 'is-top',
                    actionText :'OK',
                    queue: false,
                    type: type
                })
            },
        },
        mounted()
        {
            if(this.$session.exists()){
                this.config = {
                    headers: {
                        'Authorization': 'Bearer ' + this.$session.get('token')
                    }
                }
            }
            if(this.$route.params.id)//Kita perlu mendapatkan akses ke userId dinamis yang diteruskan 
            //ke rute kita dan menggunakannya untuk menanyakan pengguna yang benar dari API
            {
                this.editID = this.$route.params.id
                this.actionTitle = 'Ubah'
                this.koordinator_form = true
                this.standar_form= true
                this.tambahan_form= true
                console.log(this.editID)
                this.getData(this.editID)
                this.getPersonilBiro(this.editID)
                this.getPaket()
            }else{
                this.actionTitle = 'Tambah'
            }
        }
    }
</script>

<style scoped>
  img.preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
  }
  .mw-980 {
    max-width: 980px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .mw-420 {
    max-width: 420px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
</style>